// extracted by mini-css-extract-plugin
module.exports = {"links":"LinkEvent_links__-vjjW","links__empty":"LinkEvent_links__empty__3F0mE","task":"LinkEvent_task__3Lo3i","task_active":"LinkEvent_task_active__iga6D"};